import Vue from "vue";
import ru from "vee-validate/dist/locale/ru";
import VeeValidate, { Validator } from "vee-validate";

Validator.localize("ru", ru);
Vue.use(VeeValidate, { inject: false, locale: "ru" });
